import { useQuery } from 'react-query';
import chatApi from '../../chat/api/chatApi';

export const useConversations = (filters = {}, options = {}) => {
  const {
    data: response,
    isLoading,
    error,
  } = useQuery(
    ['conversations', filters, options],
    () => chatApi.listConversations({ ...filters, pageParam: options.page, limit: options.limit }),
    {
      keepPreviousData: true,
    },
  );

  return {
    conversations: response?.results || [],
    totalPages: response?.totalPages || 0,
    isLoading,
    error,
  };
}; 